import(/* webpackMode: "eager" */ "/app/src/app/(main)/error.tsx");
